"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtUpload = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtUpload = function SvgBtUpload(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.5416 14.229C21.2869 14.229 21.0832 14.4328 21.0832 14.6874V18.8572C21.0832 19.9914 20.1596 20.9116 19.0289 20.9116H8.97114C7.83701 20.9116 6.91681 19.988 6.91681 18.8572V14.6195C6.91681 14.3649 6.71307 14.1611 6.4584 14.1611C6.20374 14.1611 6 14.3649 6 14.6195V18.8572C6 20.4973 7.33447 21.8284 8.97114 21.8284H19.0289C20.6689 21.8284 22 20.4939 22 18.8572V14.6874C22 14.4362 21.7963 14.229 21.5416 14.229Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.409 10.6978L13.5414 8.56536V17.8659C13.5414 18.1205 13.7451 18.3243 13.9998 18.3243C14.2545 18.3243 14.4582 18.1205 14.4582 17.8659V8.56536L16.5906 10.6978C16.6789 10.7861 16.7978 10.8336 16.9132 10.8336C17.0321 10.8336 17.1475 10.7895 17.2358 10.6978C17.4158 10.5178 17.4158 10.2292 17.2358 10.0492L14.3224 7.13582C14.2375 7.05093 14.1187 7 13.9998 7C13.8776 7 13.7621 7.04754 13.6772 7.13582L10.7638 10.0492C10.5839 10.2292 10.5839 10.5178 10.7638 10.6978C10.9404 10.8744 11.2324 10.8744 11.409 10.6978Z",
    fill: "currentColor"
  }));
};

exports.SvgBtUpload = SvgBtUpload;